export const Types = {
  OPEN: "alertMetas/OPEN",
  CLOSE: "alertMetas/CLOSE"
};

const INITIAL_STATE = {
  open: false,
  title: null,
  body: null
};

export default function alertMetas(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.OPEN:
      return {
        ...state,
        open: true,
        title: action.payload.title,
        body: action.payload.body
      };
    case Types.CLOSE:
      return { ...state, open: false };
    default:
      return state;
  }
}

export const Creators = {
  openAlert: (title, body) => ({
    type: Types.OPEN,
    payload: { title, body }
  }),
  closeAlert: () => ({
    type: Types.CLOSE
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/alertMetas.js